export class LeaveReport {
  
     InformeId : number
     Nombre : string
     Idioma : string
     Orden : number
     SaltoPagina : number
     SaltoPagina2 : string
     Formato : string
     Poblacion : string
     Edad : string
     DiasBaja : string
     FPA : string
     DiasPrevistos : string
     GraficoDiasBaja : string
     DiasAcum : string
     GraficoDiasAcum : string
     BajaActual : string
     TipoBaja : string
     AvisoBaja : string
     ActitudNegativa : string
     NoJustificada : string
     DiagnosticoBaja : string
     ObsBaja : string
     Actuaciones : string
     InicioBaja : string
     MedicoVisita : string
     UltimaVisita : string
     UltimaGestion : string
     Solicitudes : string
     diferenciarVisitaContacto : string
     BajasAnteriores : string
     ListadoBajasAnt : string
     DiasBajasAnt : string
     AcumBajasAnt : string
     DiagnosticoBajasAnt : string
     GraficoBajasAnt : number
     AnyosBajasAnt : number
     TextoActuacion : string
     Tareas : string
     TareasTebex : string
     AutorTarea : string
     ComentarioParaEmpresa : string
     Consentimiento : string
     Inspeccion : string
     ComentariosExternos : string
     ComentariosInternos : string
     UltimoComentario : string
     Titulo : string
     ComentariosExternosEmpresa : string
     Absentista : string
     PuestoUrgente : string
     Empresa : string
     DiasAcum180 : string
     CosteAbsentismo : string
     CosteIndemnizacion : string
     ExcluirNoVisitar : string
     ComentarioParaMutua : string
     LOPD : string


}

export class LeaveReportTemplateList {
    id: number;
    name: string;
}
